export default __webpack_public_path__ + "e7c4ea0.png";